<template>
  <div>
    <!-- <Breadcrumb :links="breadcrumbs" /> -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <ul class="heading-ul mb-3">
          <li>
            <router-link to="/currencyconfig" class="">
              <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            </router-link>
          </li>
          <li>
            <h3>{{ $t("system.label.View") }} {{ currencyViewData.type }}</h3>
          </li>
        </ul>
      </div>
      <div class="vx-col md:w-full lg:w-full sm:w-full w-full mb-base">
        <vx-card>
          <div class="vx-row">
            <div class="vx-col w-full md:w-full lg:w-full">
              <ul class="horizontal-sm-btn flex mb-2 float-right">
                <li>
                  <div
                    class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                  >
                    <vs-button
                      color="primary"
                      icon-pack="feather"
                      icon="icon-edit-2"
                      class="truncate"
                      @click="editData(id)"
                      size="small"
                      >{{ $t("system.label.edit") }}</vs-button
                    >
                    <vs-button
                      icon-pack="feather"
                      icon="icon-trash"
                      color="danger"
                      type="border"
                      @click="deletePopup = true"
                      size="small"
                      >{{ $t("system.label.delete") }}</vs-button
                    >
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="p-2">
                <div class="block overflow-x-auto">
                  <table class="table w-full table-bordered table-striped">
                    <tr v-if="currencyViewData.code">
                      <td>
                        <b>{{ $t("system.label.code") }}</b>
                      </td>
                      <td>{{ currencyViewData.code }}</td>
                    </tr>
                    <tr v-if="currencyViewData.nameCode">
                      <td>
                        <b>{{ $t("system.label.internationalNameCode") }}</b>
                      </td>
                      <td>{{ currencyViewData.nameCode }}</td>
                    </tr>
                    <tr v-if="currencyViewData.decimalPlaces">
                      <td>
                        <b>{{ $t("system.label.decimalPlaces") }}</b>
                      </td>
                      <td>{{ currencyViewData.decimalPlaces }}</td>
                    </tr>
                    <tr v-if="currencyViewData.countryCode">
                      <td>
                        <b>{{ $t("system.label.countryCode") }}</b>
                      </td>
                      <td>{{ currencyViewData.countryCode }}</td>
                    </tr>
                    <tr v-if="currencyViewData.name">
                      <td>
                        <b>{{ $t("system.label.name") }}</b>
                      </td>
                      <td>{{ currencyViewData.name }}</td>
                    </tr>
                    <tr v-if="currencyViewData.status">
                      <td>
                        <b>{{ $t("system.label.status") }}</b>
                      </td>
                      <td>{{ currencyViewData.status }}</td>
                    </tr>
                    <tr v-if="currencyViewData.countryName">
                      <td>
                        <b>{{ $t("system.label.countryName") }}</b>
                      </td>
                      <td>{{ currencyViewData.countryName }}</td>
                    </tr>
                    <tr v-if="currencyViewData.displaySymbol">
                      <td class="border-none">
                        <b>{{ $t("system.label.displaySymbol") }}</b>
                      </td>
                      <td class="border-none">
                        {{ currencyViewData.displaySymbol }}
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
              <div class="centerx">
                <vs-popup
                  classContent="popup-example"
                  :title="$t('system.label.deleteCurrency')"
                  :active.sync="deletePopup"
                  class="popup-close small-popup"
                >
                  <div class="center">
                    <img src="@/assets/images/pages/delete.svg" />
                    <div class="success-msg">
                      {{ $t("system.label.areYouSureDelete") }}
                    </div>
                  </div>

                  <div class="center">
                    <span class="p-2">
                      <vs-button type="border" @click="deletePopup = false">{{
                        $t("system.label.cancel")
                      }}</vs-button></span
                    >

                    <span class="p-2">
                      <vs-button @click="deleteCurrency">{{
                        $t("system.label.confirm")
                      }}</vs-button>
                    </span>
                  </div>
                  <div style="height: 20px"></div>
                </vs-popup>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import VxCard from "@/components/vx-card/VxCard.vue";
export default {
  data() {
    return {
      id: 0,
      message: "",
      deletePopup: false,
    };
  },
  components: { VxCard },
  computed: {
    //Using mapState to get the delete Response

    ...mapState({
      deleteResponse: (state) => state.currencyMaster.getDeleteCurrencyResp,
      currencyViewData: (state) => state.currencyMaster.currencyView,
    }),

    //Using getMessageCode and bind the data in variable called MessageDatas
    currencyDatas() {
      return this.$store.getters["currencyMaster/getCurrencyCode"];
    },
    breadcrumbs() {
      let a = this.currencyViewData.type;
      return [
        {
          name: this.$t("reports.label.currencyMaster"),
          to: "/currencyconfig",
        },
        { name: this.$t("View ") + this.currencyViewData.type, to: "/" },
      ];
    },
  },
  methods: {
    editData(id) {
      this.$router.push(`/editCurrency/${id}`);
    },

    async getCurrencyById() {
      try {
        await this.$store.dispatch(
          "currencyMaster/getCurrencyViewAction",
          this.id
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },

    //delete message with the specified Store ID
    async deleteCurrency() {
      this.deletePopup = false;
      await this.$store.dispatch("currencyMaster/setdeleteCurrency", this.id);
      if (this.deleteResponse) {
        this.$vs.notify({
          title: "Successfully Deleted!",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
        });
        this.$router.push(`/currencyconfig`);
      }
    },
  },
  mounted() {
    this.id = this.$route.params.id;
    this.currency = this.$route.params.currency;
    this.getCurrencyById();
  },
};
</script>
<style scoped>
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}

.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
</style>
